<div class="row">
	<div class="col-lg-12">
		<div class="card">
			<div class="card-header align-items-center d-flex">
				<h4 class="card-title mb-0 flex-grow-1">{{ title }}</h4>
			</div>
			<div class="card-body">
				<div class="row">
					<div class="col-10">
						<app-table [tableName]="'Pending Replacements'" [tableConfig]="tableConfig" [buttons]="buttons" [theads]="theads" [data]="leads" [count]="true" [changeColor]="changeColor" (rowClicked)="editLead($event)" *ngIf="type === 'Pending Replacements'"> </app-table>
					</div>

					<div class="col-2">
						<br />
						<br />
						<br />
						<div class="card card-solved" (click)="getTodaySolvedReplacements()">
							<div class="card-body" align="center">
								<p class="title-card">Today Solved</p>
								<p class="number-card">{{ counts?.solved }}</p>
							</div>
						</div>
						<div class="card card-request" (click)="getReplacementRequests()">
							<div class="card-body" align="center">
								<p class="title-card">Requests</p>
								<p class="number-card">
									{{ counts?.requests }}
								</p>
							</div>
						</div>
						<div class="card card-news">
							<div class="card-body" align="center">
								<p class="title-card">Today New</p>
								<p class="number-card">{{ counts?.news }}</p>
							</div>
						</div>

						<div class="card card-pending" (click)="getPendingReplacements()">
							<div class="card-body" align="center">
								<p class="title-card">Total Pending</p>
								<p class="number-card">{{ counts?.pending }}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
